<template>
    <div class="service-providers-write-message-2-step w-100 h-100">
        <b-row
                class="h-100"
                no-gutters
        >
            <b-col class="form-column">
                <div class="form-wrapper w-100">
                    <lazy-public-storage-image
                            class="mb-3"
                            :file="resource.icon"
                            :alt="resource.projectLabel"
                            :width="100"
                            :height="100"
                            keep-aspect-ratio
                    />

                    <div class="form-title">
                        {{ resource.projectLabel }}
                    </div>

                    <get-connected-form
                            v-model="message"
                            :errors="messageErrors"
                            :fields="formFields"
                    />

                    <div class="cta-buttons-wrapper">
                        <b-button
                                size="lg"
                                variant="transparent"
                                class="shadow-none bg-white cancel-button"
                                @click="handleCancel"
                        >
                            Cancel
                        </b-button>

                        <b-button
                                text="Save"
                                size="lg"
                                variant="primary"
                                class="save-button d-flex justify-content-center"
                                :disabled="!canSend"
                                @click="handleSend"
                        >
                            <b-spinner
                                    v-if="isLoading"
                                    class="mr-1"
                                    small
                            />
                            Send
                        </b-button>
                    </div>
                </div>
            </b-col>
        </b-row>
</div>
</template>

<script>
    import './WriteMessage2Step.scss';
    import WriteMessageStep from './../WriteMessageStep/WriteMessageStep.vue';
    import GetConnectedForm from "./../WriteMessageStep/GetConnectedForm/GetConnectedForm.vue";
    import ServiceProviderAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/ServiceProviderAppResource";
    import isEmpty from "lodash/isEmpty";
    import AppResourceCollection from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection";
    import {FIELDS} from "@milestoneslabs/milestones-ui-kit/src/components/ServiceProviders/GetConnected/WriteMessageStep/GetConnectedForm/GetConnectedForm";

    const F_FIELDS = [
        FIELDS.FROM,
        FIELDS.EMAIL,
        FIELDS.PHONE,
        FIELDS.RESPOND_BY,
        FIELDS.MESSAGE,
        FIELDS.ATTACHMENTS,
        FIELDS.POLICY,
    ];
    export default {
        name: "WriteMessage2Step",
        extends: WriteMessageStep,
        components: {
            GetConnectedForm
        },
        props: {
            selectedServiceProviders: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            serviceProvider: {
                type: ServiceProviderAppResource,
                required: false,
                default: () => {
                    return this.selectedServiceProviders[0];
                }
            },
        },
        methods: {
            initFormFields() {
                this.formFields = F_FIELDS;
            },
            async handleSend() {
                this.isLoading = true;
                this.messageErrors = {};

                this.message.serviceProviderUuid = this.selectedServiceProviders[0].uuid;

                const errors = this.message.validateMessage();
                if (!isEmpty(errors)) {
                    this.messageErrors = errors;
                    return;
                }

                if (this.selectedServiceProviders.length) {
                    const msgCollection = new AppResourceCollection('service-provider-message');
                    for (let i = 0; i < this.selectedServiceProviders.length; i++) {
                        const message = this.setMessageData(this.selectedServiceProviders[i].uuid);
                        msgCollection.push(message);
                    }

                    try {
                        await msgCollection.create();
                        this.$emit('sent');
                    } catch (e) {
                        console.warn(e);
                        this.showNotification({
                            type: 'error',
                            message: 'Message could not be sent. Please, try again later.',
                        });
                    } finally {
                        this.isLoading = false;
                    }
                }
            }
        },
    };
</script>
